import React from 'react';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { About } from './components/sections/About';
import { Vision } from './components/sections/Vision';
import { Product } from './components/sections/Product';
import { Principles } from './components/sections/Principles';
import { Contact } from './components/sections/Contact';
export function App() {
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-0" data-mp="2mlu68f47b9oj">
      <Header data-id="element-1" data-mp="2mnnh66lukg2c" />
      <main data-id="element-2" data-mp="2mjpy1kz9roig">
        <Hero data-id="element-3" data-mp="31aqd48uiugnk" />
        <About data-id="element-4" data-mp="31b8jhyaweb97" />
        <Vision data-id="element-5" data-mp="31ayv2f5i4c5m" />
        <Product data-id="element-6" data-mp="31bianp7oiogh" />
        <Principles data-id="element-7" data-mp="31c1iue7j1yhb" />
        <Contact data-id="element-8" data-mp="2wk09p15nonvi" />
      </main>
      <Footer data-id="element-9" data-mp="2wjqhd6x524mn" />
    </div>;
}